// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lnd {
  min-height: 100vh;
  min-height: 100dvh;
  max-width: 100%;
  overflow-x: clip;
  background: #f8fafc;
  color: #0f172a;
  font-family: Inter, sans-serif;
}

.lnd *,
.lnd *::before,
.lnd *::after {
  box-sizing: border-box;
}

.lnd h1,
.lnd h2,
.lnd h3,
.lnd p {
  margin: 0;
}

.lnd-hero {
  padding: clamp(40px, 6vw, 64px) clamp(16px, 3vw, 24px) clamp(48px, 8vw, 80px);
  background: linear-gradient(180deg, rgba(240, 249, 255, 0.7), #f8fafc 70%);
  border-bottom: 1px solid #e2e8f0;
}

.lnd-hero__copy {
  max-width: 760px;
  margin: 0 auto 48px;
  text-align: center;
}

.lnd-hero__copy h1 {
  font-size: clamp(32px, 6vw, 48px);
  letter-spacing: -0.03em;
  margin-bottom: 16px;
}

.lnd-hero__copy p {
  color: #64748b;
  font-size: clamp(15px, 2.2vw, 18px);
  line-height: 1.6;
}

.lnd-hero__stage {
  max-width: 1040px;
  margin: 0 auto;
  position: relative;
}

.lnd-board {
  position: relative;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 18px 40px rgba(148, 163, 184, 0.28);
  overflow: hidden;
}

.lnd-board__bar,
.lnd-board__body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.lnd-board__bar {
  flex-wrap: wrap;
  padding: 14px 16px;
  background: rgba(248, 250, 252, 0.8);
  border-bottom: 1px solid #e2e8f0;
}

.lnd-board__clinic,
.lnd-board__add,
.lnd-board__plain,
.lnd-board__date {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  font-size: 12px;
}

.lnd-board__clinic,
.lnd-board__plain {
  background: #fff;
  border: 1px solid #e2e8f0;
  padding: 6px 10px;
  color: #334155;
}

.lnd-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #10b981;
}

.lnd-board__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.lnd-board__add {
  background: #0ea5e9;
  color: #fff;
  padding: 6px 10px;
  font-weight: 600;
}

.lnd-board__date {
  margin-left: 8px;
  padding-left: 12px;
  border-left: 1px solid #e2e8f0;
  color: #64748b;
}

.lnd-board__date strong {
  color: #0ea5e9;
}

.lnd-board__body {
  align-items: stretch;
  min-height: 360px;
}

.lnd-board__side {
  width: 168px;
  flex: none;
  padding: 12px;
  border-right: 1px solid #e2e8f0;
  background: rgba(248, 250, 252, 0.45);
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #64748b;
}

.lnd-board__side span,
.lnd-visit em {
  border-radius: 6px;
  padding: 6px 8px;
}

.lnd-board__side .is-active {
  background: rgba(224, 242, 254, 0.7);
  color: #0284c7;
}

.lnd-board__cols {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  padding: 16px;
}

.lnd-board__doc {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding-bottom: 8px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e2e8f0;
  font-size: 12px;
  font-weight: 600;
}

.lnd-board__doc em,
.lnd-visit em {
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  color: #64748b;
  background: #f1f5f9;
}

.lnd-board__col {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.lnd-visit {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px;
  background: #fff;
}

.lnd-visit div {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 4px;
  font-size: 11px;
}

.lnd-visit p {
  color: #64748b;
  font-size: 11px;
}

.lnd-visit.is-active {
  border-color: rgba(14, 165, 233, 0.45);
  background: rgba(240, 249, 255, 0.7);
}

.lnd-visit.is-active em {
  background: #0ea5e9;
  color: #fff;
}

.lnd-visit.is-wait em {
  background: #fffbeb;
  color: #b45309;
}

.lnd-visit.is-visit {
  background: rgba(248, 250, 252, 0.8);
}

.lnd-visit.is-quiet {
  opacity: 0.75;
}

.lnd-float {
  position: absolute;
  left: 24px;
  bottom: 24px;
  width: 280px;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(14, 165, 233, 0.3);
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 16px 30px rgba(12, 74, 110, 0.12);
}

.lnd-float > div:first-child,
.lnd-float__count {
  display: flex;
  flex-direction: column;
}

.lnd-float {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px 12px;
}

.lnd-float strong {
  font-size: 16px;
}

.lnd-float span,
.lnd-float li {
  color: #64748b;
  font-size: 12px;
}

.lnd-float__count {
  text-align: right;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.lnd-float__count strong {
  color: #0ea5e9;
  font-size: 28px;
  letter-spacing: 0;
  text-transform: none;
}

.lnd-float ul {
  grid-column: 1 / -1;
  margin: 8px 0 0;
  padding: 12px 0 0;
  border-top: 1px solid #e2e8f0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.lnd-float b {
  color: #0ea5e9;
  margin-right: 6px;
}

.lnd-section,
.lnd-stats,
.lnd-experience,
.lnd-footer {
  scroll-margin-top: 72px;
}

.lnd-section {
  max-width: 1120px;
  margin: 0 auto;
  padding: clamp(48px, 8vw, 88px) clamp(16px, 3vw, 24px);
}

.lnd-section__head {
  text-align: center;
  margin-bottom: 56px;
}

.lnd-section__head h2,
.lnd-experience h2,
.lnd-split h3 {
  letter-spacing: -0.02em;
}

.lnd-section__head h2 {
  display: inline-block;
  max-width: 100%;
  font-size: clamp(24px, 4vw, 30px);
  padding-bottom: 12px;
  border-bottom: 4px solid #0ea5e9;
}

.lnd-section__head p,
.lnd-split p,
.lnd-experience p,
.lnd-feature p,
.lnd-footer p,
.lnd-stats p {
  color: #64748b;
  line-height: 1.6;
}

.lnd-section__head p {
  margin-top: 12px;
  font-size: 14px;
}

.lnd-split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;
  margin-bottom: 72px;
}

.lnd-split h3,
.lnd-experience h2 {
  font-size: clamp(22px, 3vw, 28px);
  margin-bottom: 12px;
}

.lnd-split p + p {
  margin-top: 12px;
}

.lnd-panel {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
}

.lnd-panel__top,
.lnd-panel__meta,
.lnd-sites li {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.lnd-panel__top {
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 12px;
}

.lnd-panel__top em {
  font-style: normal;
  color: #059669;
  background: #ecfdf5;
  border-radius: 999px;
  padding: 2px 8px;
  text-transform: none;
  letter-spacing: 0;
}

.lnd-panel__top em.is-sky {
  color: #0284c7;
  background: transparent;
  padding: 0;
}

.lnd-chart {
  width: 100%;
  height: 140px;
}

.lnd-chart line {
  stroke: #f1f5f9;
}

.lnd-chart path {
  fill: rgba(14, 165, 233, 0.08);
  stroke: none;
}

.lnd-chart__line {
  fill: none !important;
  stroke: #0ea5e9;
  stroke-width: 2.5;
}

.lnd-panel__meta {
  border-top: 1px solid #e2e8f0;
  margin-top: 8px;
  padding-top: 8px;
  font-size: 11px;
  color: #64748b;
}

.lnd-panel__meta strong {
  color: #0f172a;
}

.lnd-sync {
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lnd-sync__ring {
  width: 168px;
  height: 168px;
  border-radius: 50%;
  border: 8px solid #e2e8f0;
  border-top-color: #0ea5e9;
  border-right-color: #0ea5e9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #0ea5e9;
  text-align: center;
}

.lnd-sync__ring strong {
  color: #0f172a;
  font-size: 13px;
}

.lnd-sync__ring span {
  color: #64748b;
  font-size: 11px;
}

.lnd-sites {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.lnd-sites li {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 12px;
}

.lnd-sites i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #10b981;
  display: inline-block;
  margin-right: 8px;
}

.lnd-sites li span:first-child {
  font-weight: 600;
}

.lnd-sites li span:last-child,
.lnd-panel__note {
  color: #64748b;
}

.lnd-panel__note {
  text-align: center;
  font-size: 11px;
  margin-top: 12px;
}

.lnd-experience {
  display: grid;
  grid-template-columns: minmax(0, 220px) minmax(0, 640px);
  justify-content: center;
  gap: clamp(24px, 4vw, 48px);
  align-items: center;
  width: 100%;
  padding: clamp(48px, 8vw, 72px) clamp(16px, 3vw, 24px);
  background: rgba(240, 249, 255, 0.55);
  border-top: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  max-width: none;
}

.lnd-experience > div:last-child {
  max-width: 640px;
}

.lnd-donut {
  width: min(220px, 70vw);
  height: min(220px, 70vw);
  margin: 0 auto;
  border-radius: 50%;
  background: conic-gradient(#0ea5e9 0 78deg, rgba(244, 63, 94, 0.85) 78deg 360deg);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 8px solid #fff;
  box-shadow: 0 0 0 1px #e2e8f0;
}

.lnd-donut div {
  width: 46%;
  height: 46%;
  border-radius: 50%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.lnd-donut strong {
  font-size: 28px;
}

.lnd-donut span {
  font-size: 10px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748b;
}

.lnd-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
}

.lnd-pills span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 12px;
  color: #334155;
}

.lnd-pills svg {
  color: #0ea5e9;
}

.lnd-features {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.lnd-feature {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 20px;
}

.lnd-feature > div {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.lnd-feature h3 {
  font-size: 16px;
}

.lnd-feature span {
  width: 36px;
  height: 36px;
  flex: none;
  border-radius: 8px;
  background: #e0f2fe;
  color: #0284c7;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.lnd-feature p {
  font-size: 13px;
}

.lnd-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  padding: 48px 24px;
  background: linear-gradient(90deg, #f0f9ff, rgba(238, 242, 255, 0.7), #f0f9ff);
  border-top: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
}

.lnd-stats article {
  max-width: 280px;
  margin: 0 auto;
}

.lnd-stats strong {
  display: block;
  color: #0ea5e9;
  font-size: 40px;
  letter-spacing: -0.03em;
  margin-bottom: 8px;
}

.lnd-stats p {
  color: #334155;
  font-size: 14px;
  font-weight: 500;
}

.lnd-footer {
  background: #fff;
  border-top: 1px solid #e2e8f0;
  padding: clamp(32px, 6vw, 48px) clamp(16px, 3vw, 24px) 24px;
}

.lnd-footer__grid,
.lnd-footer__bar {
  max-width: 1120px;
  margin: 0 auto;
}

.lnd-footer__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
}

.lnd-footer h2 {
  font-size: 12px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.lnd-footer a,
.lnd-footer__bar button {
  display: block;
  color: #64748b;
  font-size: 12px;
  text-decoration: none;
  background: none;
  border: 0;
  padding: 0;
  cursor: pointer;
  font-family: inherit;
}

.lnd-footer a + a {
  margin-top: 6px;
}

.lnd-footer a:hover,
.lnd-footer__bar button:hover {
  color: #0ea5e9;
}

.lnd-footer__bar {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
  color: #64748b;
  font-size: 12px;
}

.lnd-footer__bar nav {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
}

.lnd-login {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
}

.lnd-login__panel {
  position: relative;
  width: min(100%, 420px);
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.18);
  padding: clamp(20px, 5vw, 32px);
  max-height: calc(100dvh - 32px);
  overflow: auto;
}

.lnd-login__close,
.lnd-login__eye {
  border: 0;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.lnd-login__close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border-radius: 8px;
}

.lnd-login__close:hover,
.lnd-login__eye:hover {
  color: #475569;
  background: #f1f5f9;
}

.lnd-login__intro {
  text-align: center;
  margin-bottom: 20px;
}

.lnd-login__intro .lnd-brand__mark {
  width: 48px;
  height: 48px;
  margin: 0 auto 12px;
}

.lnd-login__intro h2 {
  font-size: 20px;
}

.lnd-login__intro p,
.lnd-login label {
  color: #64748b;
  font-size: 12px;
}

.lnd-login label {
  display: block;
  margin: 12px 0 6px;
  color: #334155;
  font-weight: 600;
}

.lnd-login label span {
  color: #e11d48;
}

.lnd-field {
  position: relative;
}

.lnd-field svg {
  position: absolute;
  left: 10px;
  top: 10px;
  color: #94a3b8;
}

.lnd-field input {
  width: 100%;
  height: 36px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0 36px 0 34px;
  font-size: 12px;
  color: #0f172a;
  box-sizing: border-box;
}

.lnd-field input:focus {
  outline: none;
  border-color: #0ea5e9;
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2);
}

.lnd-login__eye {
  position: absolute;
  right: 6px;
  top: 4px;
  width: 28px;
  height: 28px;
}

.lnd-login__error {
  margin-top: 10px;
  color: #dc2626;
  font-size: 12px;
}

.lnd-login__submit {
  width: 100%;
  height: 40px;
  margin-top: 16px;
  border: 0;
  border-radius: 8px;
  background: #0ea5e9;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
}

.lnd-login__submit:hover {
  background: #0284c7;
}

.lnd-login__submit:disabled {
  opacity: 0.7;
  cursor: progress;
}

@media (max-width: 1200px) {
  .lnd-features {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lnd-board__side,
  .lnd-float {
    display: none;
  }

  .lnd-board__cols {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lnd-board__body {
    min-height: 0;
  }
}

@media (max-width: 900px) {
  .lnd-split,
  .lnd-experience,
  .lnd-footer__grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .lnd-split {
    gap: 20px;
    margin-bottom: 48px;
  }

  .lnd-section__head {
    margin-bottom: 32px;
  }

  .lnd-experience > div:last-child {
    max-width: none;
  }
}

@media (max-width: 720px) {
  .lnd-features,
  .lnd-board__cols {
    grid-template-columns: minmax(0, 1fr);
  }

  .lnd-board__date {
    margin-left: 0;
    padding-left: 0;
    border-left: 0;
  }

  .lnd-hero__copy {
    margin-bottom: 28px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Landing/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;EACE,6EAA6E;EAC7E,0EAA0E;EAC1E,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;;EAIE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,+BAA+B;EAC/B,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,qCAAqC;EACrC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,+CAA+C;AACjD;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iCAAiC;EACjC,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;;;;;;EAME,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;;EAGE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,sDAAsD;EACtD,qCAAqC;EACrC,6BAA6B;EAC7B,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,iFAAiF;EACjF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;EAClB,8EAA8E;EAC9E,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,2DAA2D;AAC7D;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,+BAA+B;EAC/B,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;;EAEE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;;IAGE,qCAAqC;EACvC;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,qCAAqC;EACvC;;EAEA;IACE,cAAc;IACd,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".lnd {\n  min-height: 100vh;\n  min-height: 100dvh;\n  max-width: 100%;\n  overflow-x: clip;\n  background: #f8fafc;\n  color: #0f172a;\n  font-family: Inter, sans-serif;\n}\n\n.lnd *,\n.lnd *::before,\n.lnd *::after {\n  box-sizing: border-box;\n}\n\n.lnd h1,\n.lnd h2,\n.lnd h3,\n.lnd p {\n  margin: 0;\n}\n\n.lnd-hero {\n  padding: clamp(40px, 6vw, 64px) clamp(16px, 3vw, 24px) clamp(48px, 8vw, 80px);\n  background: linear-gradient(180deg, rgba(240, 249, 255, 0.7), #f8fafc 70%);\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.lnd-hero__copy {\n  max-width: 760px;\n  margin: 0 auto 48px;\n  text-align: center;\n}\n\n.lnd-hero__copy h1 {\n  font-size: clamp(32px, 6vw, 48px);\n  letter-spacing: -0.03em;\n  margin-bottom: 16px;\n}\n\n.lnd-hero__copy p {\n  color: #64748b;\n  font-size: clamp(15px, 2.2vw, 18px);\n  line-height: 1.6;\n}\n\n.lnd-hero__stage {\n  max-width: 1040px;\n  margin: 0 auto;\n  position: relative;\n}\n\n.lnd-board {\n  position: relative;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 18px 40px rgba(148, 163, 184, 0.28);\n  overflow: hidden;\n}\n\n.lnd-board__bar,\n.lnd-board__body {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.lnd-board__bar {\n  flex-wrap: wrap;\n  padding: 14px 16px;\n  background: rgba(248, 250, 252, 0.8);\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.lnd-board__clinic,\n.lnd-board__add,\n.lnd-board__plain,\n.lnd-board__date {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border-radius: 6px;\n  font-size: 12px;\n}\n\n.lnd-board__clinic,\n.lnd-board__plain {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  padding: 6px 10px;\n  color: #334155;\n}\n\n.lnd-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #10b981;\n}\n\n.lnd-board__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.lnd-board__add {\n  background: #0ea5e9;\n  color: #fff;\n  padding: 6px 10px;\n  font-weight: 600;\n}\n\n.lnd-board__date {\n  margin-left: 8px;\n  padding-left: 12px;\n  border-left: 1px solid #e2e8f0;\n  color: #64748b;\n}\n\n.lnd-board__date strong {\n  color: #0ea5e9;\n}\n\n.lnd-board__body {\n  align-items: stretch;\n  min-height: 360px;\n}\n\n.lnd-board__side {\n  width: 168px;\n  flex: none;\n  padding: 12px;\n  border-right: 1px solid #e2e8f0;\n  background: rgba(248, 250, 252, 0.45);\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.lnd-board__side span,\n.lnd-visit em {\n  border-radius: 6px;\n  padding: 6px 8px;\n}\n\n.lnd-board__side .is-active {\n  background: rgba(224, 242, 254, 0.7);\n  color: #0284c7;\n}\n\n.lnd-board__cols {\n  flex: 1;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  padding: 16px;\n}\n\n.lnd-board__doc {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding-bottom: 8px;\n  margin-bottom: 10px;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.lnd-board__doc em,\n.lnd-visit em {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 10px;\n  color: #64748b;\n  background: #f1f5f9;\n}\n\n.lnd-board__col {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.lnd-visit {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 10px;\n  background: #fff;\n}\n\n.lnd-visit div {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 4px;\n  font-size: 11px;\n}\n\n.lnd-visit p {\n  color: #64748b;\n  font-size: 11px;\n}\n\n.lnd-visit.is-active {\n  border-color: rgba(14, 165, 233, 0.45);\n  background: rgba(240, 249, 255, 0.7);\n}\n\n.lnd-visit.is-active em {\n  background: #0ea5e9;\n  color: #fff;\n}\n\n.lnd-visit.is-wait em {\n  background: #fffbeb;\n  color: #b45309;\n}\n\n.lnd-visit.is-visit {\n  background: rgba(248, 250, 252, 0.8);\n}\n\n.lnd-visit.is-quiet {\n  opacity: 0.75;\n}\n\n.lnd-float {\n  position: absolute;\n  left: 24px;\n  bottom: 24px;\n  width: 280px;\n  background: rgba(255, 255, 255, 0.96);\n  border: 1px solid rgba(14, 165, 233, 0.3);\n  border-radius: 12px;\n  padding: 16px;\n  box-shadow: 0 16px 30px rgba(12, 74, 110, 0.12);\n}\n\n.lnd-float > div:first-child,\n.lnd-float__count {\n  display: flex;\n  flex-direction: column;\n}\n\n.lnd-float {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 8px 12px;\n}\n\n.lnd-float strong {\n  font-size: 16px;\n}\n\n.lnd-float span,\n.lnd-float li {\n  color: #64748b;\n  font-size: 12px;\n}\n\n.lnd-float__count {\n  text-align: right;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.lnd-float__count strong {\n  color: #0ea5e9;\n  font-size: 28px;\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n.lnd-float ul {\n  grid-column: 1 / -1;\n  margin: 8px 0 0;\n  padding: 12px 0 0;\n  border-top: 1px solid #e2e8f0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.lnd-float b {\n  color: #0ea5e9;\n  margin-right: 6px;\n}\n\n.lnd-section,\n.lnd-stats,\n.lnd-experience,\n.lnd-footer {\n  scroll-margin-top: 72px;\n}\n\n.lnd-section {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: clamp(48px, 8vw, 88px) clamp(16px, 3vw, 24px);\n}\n\n.lnd-section__head {\n  text-align: center;\n  margin-bottom: 56px;\n}\n\n.lnd-section__head h2,\n.lnd-experience h2,\n.lnd-split h3 {\n  letter-spacing: -0.02em;\n}\n\n.lnd-section__head h2 {\n  display: inline-block;\n  max-width: 100%;\n  font-size: clamp(24px, 4vw, 30px);\n  padding-bottom: 12px;\n  border-bottom: 4px solid #0ea5e9;\n}\n\n.lnd-section__head p,\n.lnd-split p,\n.lnd-experience p,\n.lnd-feature p,\n.lnd-footer p,\n.lnd-stats p {\n  color: #64748b;\n  line-height: 1.6;\n}\n\n.lnd-section__head p {\n  margin-top: 12px;\n  font-size: 14px;\n}\n\n.lnd-split {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 40px;\n  align-items: center;\n  margin-bottom: 72px;\n}\n\n.lnd-split h3,\n.lnd-experience h2 {\n  font-size: clamp(22px, 3vw, 28px);\n  margin-bottom: 12px;\n}\n\n.lnd-split p + p {\n  margin-top: 12px;\n}\n\n.lnd-panel {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 20px;\n}\n\n.lnd-panel__top,\n.lnd-panel__meta,\n.lnd-sites li {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n}\n\n.lnd-panel__top {\n  font-size: 12px;\n  font-weight: 600;\n  color: #334155;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 12px;\n}\n\n.lnd-panel__top em {\n  font-style: normal;\n  color: #059669;\n  background: #ecfdf5;\n  border-radius: 999px;\n  padding: 2px 8px;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.lnd-panel__top em.is-sky {\n  color: #0284c7;\n  background: transparent;\n  padding: 0;\n}\n\n.lnd-chart {\n  width: 100%;\n  height: 140px;\n}\n\n.lnd-chart line {\n  stroke: #f1f5f9;\n}\n\n.lnd-chart path {\n  fill: rgba(14, 165, 233, 0.08);\n  stroke: none;\n}\n\n.lnd-chart__line {\n  fill: none !important;\n  stroke: #0ea5e9;\n  stroke-width: 2.5;\n}\n\n.lnd-panel__meta {\n  border-top: 1px solid #e2e8f0;\n  margin-top: 8px;\n  padding-top: 8px;\n  font-size: 11px;\n  color: #64748b;\n}\n\n.lnd-panel__meta strong {\n  color: #0f172a;\n}\n\n.lnd-sync {\n  min-height: 220px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.lnd-sync__ring {\n  width: 168px;\n  height: 168px;\n  border-radius: 50%;\n  border: 8px solid #e2e8f0;\n  border-top-color: #0ea5e9;\n  border-right-color: #0ea5e9;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  color: #0ea5e9;\n  text-align: center;\n}\n\n.lnd-sync__ring strong {\n  color: #0f172a;\n  font-size: 13px;\n}\n\n.lnd-sync__ring span {\n  color: #64748b;\n  font-size: 11px;\n}\n\n.lnd-sites {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.lnd-sites li {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 10px 12px;\n  font-size: 12px;\n}\n\n.lnd-sites i {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #10b981;\n  display: inline-block;\n  margin-right: 8px;\n}\n\n.lnd-sites li span:first-child {\n  font-weight: 600;\n}\n\n.lnd-sites li span:last-child,\n.lnd-panel__note {\n  color: #64748b;\n}\n\n.lnd-panel__note {\n  text-align: center;\n  font-size: 11px;\n  margin-top: 12px;\n}\n\n.lnd-experience {\n  display: grid;\n  grid-template-columns: minmax(0, 220px) minmax(0, 640px);\n  justify-content: center;\n  gap: clamp(24px, 4vw, 48px);\n  align-items: center;\n  width: 100%;\n  padding: clamp(48px, 8vw, 72px) clamp(16px, 3vw, 24px);\n  background: rgba(240, 249, 255, 0.55);\n  border-top: 1px solid #e2e8f0;\n  border-bottom: 1px solid #e2e8f0;\n  max-width: none;\n}\n\n.lnd-experience > div:last-child {\n  max-width: 640px;\n}\n\n.lnd-donut {\n  width: min(220px, 70vw);\n  height: min(220px, 70vw);\n  margin: 0 auto;\n  border-radius: 50%;\n  background: conic-gradient(#0ea5e9 0 78deg, rgba(244, 63, 94, 0.85) 78deg 360deg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 8px solid #fff;\n  box-shadow: 0 0 0 1px #e2e8f0;\n}\n\n.lnd-donut div {\n  width: 46%;\n  height: 46%;\n  border-radius: 50%;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.lnd-donut strong {\n  font-size: 28px;\n}\n\n.lnd-donut span {\n  font-size: 10px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.lnd-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.lnd-pills span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 6px 10px;\n  font-size: 12px;\n  color: #334155;\n}\n\n.lnd-pills svg {\n  color: #0ea5e9;\n}\n\n.lnd-features {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.lnd-feature {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n.lnd-feature > div {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.lnd-feature h3 {\n  font-size: 16px;\n}\n\n.lnd-feature span {\n  width: 36px;\n  height: 36px;\n  flex: none;\n  border-radius: 8px;\n  background: #e0f2fe;\n  color: #0284c7;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.lnd-feature p {\n  font-size: 13px;\n}\n\n.lnd-stats {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 24px;\n  padding: 48px 24px;\n  background: linear-gradient(90deg, #f0f9ff, rgba(238, 242, 255, 0.7), #f0f9ff);\n  border-top: 1px solid #e2e8f0;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.lnd-stats article {\n  max-width: 280px;\n  margin: 0 auto;\n}\n\n.lnd-stats strong {\n  display: block;\n  color: #0ea5e9;\n  font-size: 40px;\n  letter-spacing: -0.03em;\n  margin-bottom: 8px;\n}\n\n.lnd-stats p {\n  color: #334155;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.lnd-footer {\n  background: #fff;\n  border-top: 1px solid #e2e8f0;\n  padding: clamp(32px, 6vw, 48px) clamp(16px, 3vw, 24px) 24px;\n}\n\n.lnd-footer__grid,\n.lnd-footer__bar {\n  max-width: 1120px;\n  margin: 0 auto;\n}\n\n.lnd-footer__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 24px;\n}\n\n.lnd-footer h2 {\n  font-size: 12px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n}\n\n.lnd-footer a,\n.lnd-footer__bar button {\n  display: block;\n  color: #64748b;\n  font-size: 12px;\n  text-decoration: none;\n  background: none;\n  border: 0;\n  padding: 0;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.lnd-footer a + a {\n  margin-top: 6px;\n}\n\n.lnd-footer a:hover,\n.lnd-footer__bar button:hover {\n  color: #0ea5e9;\n}\n\n.lnd-footer__bar {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-top: 40px;\n  padding-top: 20px;\n  border-top: 1px solid #e2e8f0;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.lnd-footer__bar nav {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 20px;\n}\n\n.lnd-login {\n  position: fixed;\n  inset: 0;\n  z-index: 80;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background: rgba(15, 23, 42, 0.4);\n  backdrop-filter: blur(4px);\n}\n\n.lnd-login__panel {\n  position: relative;\n  width: min(100%, 420px);\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.18);\n  padding: clamp(20px, 5vw, 32px);\n  max-height: calc(100dvh - 32px);\n  overflow: auto;\n}\n\n.lnd-login__close,\n.lnd-login__eye {\n  border: 0;\n  background: transparent;\n  color: #94a3b8;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.lnd-login__close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n}\n\n.lnd-login__close:hover,\n.lnd-login__eye:hover {\n  color: #475569;\n  background: #f1f5f9;\n}\n\n.lnd-login__intro {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.lnd-login__intro .lnd-brand__mark {\n  width: 48px;\n  height: 48px;\n  margin: 0 auto 12px;\n}\n\n.lnd-login__intro h2 {\n  font-size: 20px;\n}\n\n.lnd-login__intro p,\n.lnd-login label {\n  color: #64748b;\n  font-size: 12px;\n}\n\n.lnd-login label {\n  display: block;\n  margin: 12px 0 6px;\n  color: #334155;\n  font-weight: 600;\n}\n\n.lnd-login label span {\n  color: #e11d48;\n}\n\n.lnd-field {\n  position: relative;\n}\n\n.lnd-field svg {\n  position: absolute;\n  left: 10px;\n  top: 10px;\n  color: #94a3b8;\n}\n\n.lnd-field input {\n  width: 100%;\n  height: 36px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 0 36px 0 34px;\n  font-size: 12px;\n  color: #0f172a;\n  box-sizing: border-box;\n}\n\n.lnd-field input:focus {\n  outline: none;\n  border-color: #0ea5e9;\n  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2);\n}\n\n.lnd-login__eye {\n  position: absolute;\n  right: 6px;\n  top: 4px;\n  width: 28px;\n  height: 28px;\n}\n\n.lnd-login__error {\n  margin-top: 10px;\n  color: #dc2626;\n  font-size: 12px;\n}\n\n.lnd-login__submit {\n  width: 100%;\n  height: 40px;\n  margin-top: 16px;\n  border: 0;\n  border-radius: 8px;\n  background: #0ea5e9;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\n.lnd-login__submit:hover {\n  background: #0284c7;\n}\n\n.lnd-login__submit:disabled {\n  opacity: 0.7;\n  cursor: progress;\n}\n\n@media (max-width: 1200px) {\n  .lnd-features {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .lnd-board__side,\n  .lnd-float {\n    display: none;\n  }\n\n  .lnd-board__cols {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .lnd-board__body {\n    min-height: 0;\n  }\n}\n\n@media (max-width: 900px) {\n  .lnd-split,\n  .lnd-experience,\n  .lnd-footer__grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .lnd-split {\n    gap: 20px;\n    margin-bottom: 48px;\n  }\n\n  .lnd-section__head {\n    margin-bottom: 32px;\n  }\n\n  .lnd-experience > div:last-child {\n    max-width: none;\n  }\n}\n\n@media (max-width: 720px) {\n  .lnd-features,\n  .lnd-board__cols {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .lnd-board__date {\n    margin-left: 0;\n    padding-left: 0;\n    border-left: 0;\n  }\n\n  .lnd-hero__copy {\n    margin-bottom: 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
